import { breakpointClassNames } from "@components/HomePage/Components/breakpointClassNames";
import { HomeScrollContext, useHomeScrollOwner } from "@components/HomePage/scroll/useHomeScroll";
import { useHomeTitlebarOffset } from "@components/HomePage/useHomeTitlebarOffset";
import { useBreakpoint } from "@core-ui/hooks/useBreakpoint";
import t from "@ext/localization/locale/translate";
import { LegacyScrollShadowContainer } from "@ui-kit/ScrollShadowContainer";
import type React from "react";

const homePageWrapperClassName = [
	"bg-primary-bg flex flex-col h-full overflow-auto font-[Roboto,sans-serif]",
	"[&_.shadow-scroll>div]:flex [&_.shadow-scroll>div]:flex-col [&>div:has(.scroll-area)]:h-full",
	"[&_.groups]:mt-[1.8rem] [&_:is(.groups,.top-menu,.bottom-info)]:w-full [&_:is(.groups,.top-menu,.bottom-info)]:mx-auto",
	"[&_[data-catalog-card]]:w-full [&_[data-folder]]:w-full",
].join(" ");

export const HomePageWrapper = ({ children }: { children: React.ReactNode }) => {
	const breakpoint = useBreakpoint();
	const { ref, scroll } = useHomeScrollOwner();
	const titlebarOffset = useHomeTitlebarOffset();
	return (
		<div
			className={`${homePageWrapperClassName} ${breakpointClassNames[breakpoint]}`}
			style={{ "--home-titlebar-offset": titlebarOffset } as React.CSSProperties}
		>
			<LegacyScrollShadowContainer
				className="flex flex-col shadow-scroll h-full"
				contentProps={{ role: "region", "aria-label": t("home") }}
				ref={ref}
				shadowTopClassName="top-shadow"
			>
				<HomeScrollContext.Provider value={scroll}>{children}</HomeScrollContext.Provider>
			</LegacyScrollShadowContainer>
		</div>
	);
};
